<template>
	<div class="pages">
		<div class="tab-bar-content" v-show="isTabBar">
			<z-tab-bar :list-obj="tabBarParams.list" :active="tabBarParams.active" @handleClickTabBar = "handleTab"></z-tab-bar>
		</div>
		<div class="list">
			<section class="module news-list" v-if="params.type == 'news'">
				<ul>
					<li v-for="(item,index) in news.item || []" class="fx" @click="handleSelectMaterial(item,index)">
						<em v-show="selected == index" class="selected icon-gou fx-align" @click.stop="handleCancelSelected"></em>
						<div class="pic fx-shrink">
							<img width="100" height="100" :src="item.content.news_item[0].thumb_url | showWxImages" />
						</div>
						<div class="title fx-fill">
							<ol>
								<li v-for="(subItem,subIndex) in item.content.news_item || []">
									<a>{{subIndex+1}}.{{subItem.title}}</a>
								</li>
							</ol>
						</div>
						<div class="time">
							{{item.update_time | momentUnixFmt}}
						</div>
					</li>
				</ul>
			</section>
			<section class="module image-list" v-if="params.type == 'image'">
				<ul class="fx fx-wrap">
					<li v-for="(item,index) in image.item || []" @click="handleSelectMaterial(item,index)">
						<div class="pic">
							<img width="200" height="200" :src="item.url | showWxImages" />
							<p class="text-ellipsis">{{item.name}}</p>
							<em v-show="selected == index" class="selected icon-gou fx-align" @click.stop="handleCancelSelected"></em>
						</div>
					</li>
				</ul>
			</section>
			<section class="module voice-list" v-if="params.type == 'voice'">
				<ul>
					<li v-for="(item,index) in voice.item || []" @click="handleSelectMaterial(item,index)">
						<div class="item fx fx-y-center b-r-3">
							<p class="icon-video fx-shrink"></p>
							<div class="fx-fill text">
								<p class="text-ellipsis">{{item.name}}</p>
								<p>{{item.update_time | momentFmt}}</p>
							</div>
							<em v-show="selected == index" class="selected icon-gou fx-align" @click.stop="handleCancelSelected"></em>
						</div>
					</li>
				</ul>
			</section>
			<section class="module video-list" v-if="params.type == 'video'" >
				<ul>
					<li v-for="(item,index) in video.item || []" @click="handleSelectMaterial(item,index)">
						<div class="item fx fx-y-center b-r-3">
							<p class="icon-video fx-shrink"></p>
							<div class="fx-fill text">
								<p class="text-ellipsis">{{item.name}}</p>
								<p>{{item.update_time | momentFmt}}</p>
							</div>
							<em v-show="selected == index" class="selected icon-gou fx-align" @click.stop="handleCancelSelected"></em>
						</div>
					</li>
				</ul>
			</section>
			<section v-show ="totalCount <=0" class="p-20">
				<p align="center">暂无相关数据</p>
			</section>
			
		</div>
		<section class="fx oper-page">
			<div class="fx-fill">
				<a class="z-btn z-btn-primary b-r-3" @click="handleLinkWx">添加素材</a>
				<!--<a class="z-btn z-btn-default b-r-3 m-l-10" @click="handleRefresh">同步微信数据</a>-->
			</div>
			<z-pages :offset="params.offset" :count="params.count" :total-count="totalCount" @handleOffset="handleOffset"></z-pages>
		</section>
	</div>
</template>
<script>
	import { mapActions, mapState } from 'vuex'
	export default {
		name: 'z-material',
		components: {
		},
		data() {
			return {
				selected:null,
				tabBarParams:{
					list:[{
						title: '图文',
						type: 'news'
					},{
						title: '图片',
						type: 'image'
					},{
						title: '语音',
						type: 'voice'
					},{
						title: '视频',
						type: 'video'
					}],
					active:'news'
				},
				params: {
					type:this.type,
					offset: 0,
					count: 10,
					isRefresh:false
				}
			}
		},
		props: {
			type:{
				type:String,
				default: 'news'
			},
			isGetMaterial:{
				type: Boolean,
				default: false
			},
			isTabBar:{
				type: Boolean,
				default: false
			}
		},
		watch :{//监听数据变化
    		isGetMaterial(val){
    			if(val){
    				this.params.type =this.type
    				this.tabBarParams.active = this.type
    				this.selected = null
    				this.handleGetMaterials()
    			}
    		}
	  	},
	  	mounted (){
	    },
		/*
		 * 属性计算
		 */
		computed: {
			totalCount() {
				let count = 0
				switch(this.params.type) {
					case 'news':
						count = this.news.total_count
						break;
					case 'image':
						count = this.image.total_count
						break;
					case 'video':
						count = this.video.total_count
						break;
					case 'voice':
						count = this.voice.total_count
						break;
					default:
						break;
				}
				return count
			},
			...mapState({
				news: state => state.material.news,
				image: state => state.material.image,
				video: state => state.material.video,
				voice: state => state.material.voice
			})
		},
		/*
		 * 事件处理
		 */
		methods: {
			async handleLinkWx(){
				try{
					await this.$confirm('本平台暂时不支持添加素材,前往微信公众号后台添加, 是否继续?', '提示', {
			          confirmButtonText: '确定',
			          cancelButtonText: '取消',
			          type: 'warning'
			        })
					window.open("https://mp.weixin.qq.com")
				}catch(e){
					this.$log('取消')
				}
			},
			handleCancelSelected(){//取消选中
				this.selected = null
				this.$emit('handleSelectMaterial',null)
			},
			handleSelectMaterial(item={},index=null){
				this.selected = index
				this.$emit('handleSelectMaterial',item)
			},
			handleOffset(offset) { //处理翻页
				this.params.offset = offset
				this.handleGetMaterials()
			},
			handleTab(type) { //类型切换
				this.selected = null
				this.tabBarParams.active = type
				this.params.type = type
				this.handleGetMaterials()
			},
			handleRefresh(){//同步微信数据
				this.params.offset = 0
				this.handleGetMaterials()
			},
			handleGetMaterials() { //获取素材成功
				try{
					this.getMaterials(this.params)
				}catch(e){
					this.$errorMsg(e)
				}
			},
			...mapActions(['getMaterials']),
		},
	}
</script>
<style scoped lang="scss">
	@import "src/assets/css/common.scss";
	.tab-bar-content{
		    border-bottom: 1px solid $color-border;
	}
	.module{
		padding: px-em(10px);
		li{
			padding: px-em(10px);
			cursor: pointer;
			position: relative;
			.item{
				position: relative;
				width: px-em(350px);
				height:px-em(100px);
				overflow: hidden;
				border: $color-border 1px solid;
				font-size:12px;
				.text{
					padding: px-em(10px) px-em(20px);
					p{
						padding:px-em(5px) 0;
					}
				}
				.icon{
					color: $color-btn;
					font-size: px-em(50px);
					padding: px-em(20px);
					border-right: $color-border 1px solid;
				}
			}
			.selected{
				position: absolute;
				background: rgba(0,0,0,0.6);
				left: 0;
				top: 0;
				width: 100%;
				height: 100%;
				z-index: 3;
				font-size: px-em(50px);
				color: $color-white !important;
			}
		}
		
	}
	.oper-page{
		border-top: $color-border 1px solid;
		padding: px-em(20px);
		background: $color-white;
	}
	.list {
		background: $color-white;
		min-height: px-em(200px);
	}
	
	.news-list {
		ul>li {
			transition: all 0.2s linear;
    		-webkit-transition: all 0.2s linear;
			padding: px-em(20px);
			border-bottom: $color-border 1px solid;
			&:hover{
				background: rgba(204, 204, 204, 0.1);
			}
			&:last-child{
				border-bottom:none;
			}
			ol>li {
				padding-left: px-em(20px);
				a:hover{
					text-decoration: underline;
				}
			}
		}
		.time {
			padding: 0 px-em(20px);
		}
		.operation {
			padding: 0 px-em(40px);
		}
	}
	
	.image-list {
		li {
			padding: 5px;
			.pic {
				position: relative;
				p {
					position: absolute;
					left: 0;
					bottom: 0;
					width: 100%;
					color: $color-white;
					height: px-em(50px);
					line-height: px-em(50px);
					text-align: center;
					background: rgba(0, 0, 0, 0.5);
				}
			}
		}
	}
</style>


// WEBPACK FOOTER //
// Material.vue?4d3d65c0